import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6dd53b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-reports" }
const _hoisted_2 = { class: "periodontal-reports__creation" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_4 = {
  key: 0,
  class: "periodontal-reports__creation-text"
}
const _hoisted_5 = { class: "periodontal-reports__reports" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "periodontal-reports__report-header" }
const _hoisted_8 = { class: "periodontal-reports__report-date" }
const _hoisted_9 = {
  key: 0,
  class: "periodontal-reports__report-screening"
}
const _hoisted_10 = { class: "periodontal-reports__report-number" }
const _hoisted_11 = { class: "divider" }
const _hoisted_12 = { class: "modal__header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__title" }, "Выберите отчёт", -1))
const _hoisted_14 = { class: "modal__body" }
const _hoisted_15 = { class: "modal__row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__description modal__subtitle" }, " Полный пародонтальный отчёт ", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Полный отчёт ")
const _hoisted_18 = { class: "modal__row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__block" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "modal__description modal__subtitle" }, "Скрининг")
], -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Скрининг ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          disabled: _ctx.isSubscriptionEnded,
          class: "periodontal-reports__creation-button",
          round: "",
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalVisible = true))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"]),
        (!_ctx.isPreviewMode && !_ctx.reports.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " У пациента пока нет ни одного отчёта. Для создания отчета нажмите кнопку “Новый отчет” "))
          : _createCommentVNode("", true)
      ]),
      (_ctx.reports.length)
        ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
          return (_openBlock(), _createElementBlock("div", {
            key: report.id,
            class: "periodontal-reports__report",
            onClick: ($event: any) => (_ctx.handleOpenReportPage(report.id, report.isScreening))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{
            'periodontal-reports__report-content--active':
              _ctx.activeReportId === report.id,
          }, "periodontal-reports__report-content"])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.getDate(report.date_at)), 1),
                (report.isScreening)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " СКР "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_10, "№" + _toDisplayString(report.id), 1)
            ], 2),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_divider)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      "show-close": false,
      width: "538"
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_icon_template, {
            class: "modal__header-icon",
            height: "25",
            name: "close",
            width: "25",
            onClick: close
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_button, {
              disabled: _ctx.isSubscriptionEndedPeriodontal,
              round: "",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleOpenReportCreationPage(_ctx.REPORT_VIEW.periodontal)))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_el_button, {
              round: "",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleOpenReportCreationPage(_ctx.REPORT_VIEW.screening)))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}